import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {LoggingService} from '../../../app/shared/services/logging.service';


@NgModule({
  imports: [
    CommonModule,
  ],
})
export class TorchFleetTeamModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchFleetTeamModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchFleetTeamModule is already loaded. Import in your base TorchBackend only.');
    }

    logger.log('Loaded TorchFleetTeamModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchFleetTeamModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
